import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, timer } from 'rxjs';
import { debounce, distinctUntilChanged } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

/**
 * Estado global de requisições em andamento, consumido pelo TopLoaderComponent.
 * A barra só aparece se houver requisição pendente por mais de SHOW_DELAY_MS
 * e some imediatamente ao concluir — requisições rápidas não geram flash algum.
 */
@Injectable({ providedIn: 'root' })
export class LoadingService {
    private static readonly SHOW_DELAY_MS = 400;

    private pending = 0;
    private readonly hasPending$ = new BehaviorSubject<boolean>(false);

    readonly visible = signal(false);

    constructor() {
        this.hasPending$
            .pipe(
                debounce(show => (show ? timer(LoadingService.SHOW_DELAY_MS) : timer(0))),
                distinctUntilChanged(),
                takeUntilDestroyed()
            )
            .subscribe(show => this.visible.set(show));
    }

    taskStarted(): void {
        this.pending++;
        if (this.pending === 1) {
            this.hasPending$.next(true);
        }
    }

    taskFinished(): void {
        this.pending = Math.max(0, this.pending - 1);
        if (this.pending === 0) {
            this.hasPending$.next(false);
        }
    }
}
